import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-building',
      title: 'Real Estate Purchase & Sales',
      description: 'Expert guidance in buying and selling properties, ensuring secure and profitable transactions.',
      image: '/P1.png'
    },
    {
      icon: 'fas fa-map-marked-alt',
      title: 'Land & Estate Development',
      description: 'Comprehensive land and estate development services, from planning to construction and management.',
      image: '/P2.png'
    },
    {
      icon: 'fas fa-seedling',
      title: 'Agricultural Development & Production',
      description: 'Supporting sustainable agriculture and production for food security and economic growth.',
      image: '/P3.png'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Our Services</h2>
          <p>We specialize in real estate purchase and sales, land and estate development, and agricultural development and production.</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;